import { getCmsAuthorizationHeaderObject, getCmsUrl, getDeepTranslationsFilter, serialize } from "@/services/cms";
import { httpClient } from "@/services/http";
import { LocaleCode } from "@/services/i18n";

import { getCompanyMetaResponseSchema } from "./get-company-meta.schema";
import type { GetCompanyMetaRequestProps } from "./get-company-meta.types";

export const GET_COMPANY_META_ENDPOINT = "/items/company_meta";

export const getCompanyMetaRequest = async ({ locale }: GetCompanyMetaRequestProps) => {
  const response = await httpClient
    .get(getCmsUrl(GET_COMPANY_META_ENDPOINT), {
      headers: getCmsAuthorizationHeaderObject(),
      params: {
        deep: { ...getDeepTranslationsFilter(LocaleCode.fromLocale(locale)) },
        fields: ["*", "translations.*", "translations.contact_items.*"],
      },
      next: {
        tags: ["company_meta"],
        revalidate: false,
      },
      queryOptions: { arrayFormat: "comma" },
    })
    .then(serialize);

  return getCompanyMetaResponseSchema.parse(response);
};
